module.exports = __webpack_public_path__ + "img/耿艳娜.7800d155.jpg";